import { useI18n } from 'hooks/useI18n';
import { Fragment, useMemo } from 'react';
import Masonry from 'react-masonry-css';
import Fade from 'react-reveal/Fade';
import { OfferCard } from './card/OfferCard';
import { StyledGrid, StyledGridSeparator } from './OfferGrid.styled';
import { OfferGridProps } from './OfferGrid.types';

export const OfferGrid: React.FC<OfferGridProps> = (props) => {
  const { t } = useI18n('job-offer-list');

  const breakpointColumnsObj = {
    default: 3,
    1175: 2,
    1056: 3,
    890: 2,
    550: 1
  };

  const checkInactive = useMemo((): boolean => {
    return props.offers.some((offer) => !offer.active);
  }, [props.offers]);

  return (
    <>
      {props.offers.length > 0 && (
        <StyledGrid className={props.className}>
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="masonry-grid"
            columnClassName="masonry-column"
          >
            {props.offers.map((offer, i) => (
              <Fragment key={i}>
                {offer.active && (
                  <Fade bottom distance="10px" ssrReveal={true}>
                    <OfferCard
                      offer={offer}
                      isDefaultFilter={props.isDefaultFilter}
                    />
                  </Fade>
                )}
              </Fragment>
            ))}
          </Masonry>

          {checkInactive && (
            <StyledGridSeparator>
              <span>{t('closed_offers')}</span>
            </StyledGridSeparator>
          )}

          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="masonry-grid"
            columnClassName="masonry-column"
          >
            {props.offers.map((offer, i) => (
              <Fragment key={i}>
                {!offer.active && (
                  <Fade bottom distance="10px">
                    <OfferCard offer={offer} />
                  </Fade>
                )}
              </Fragment>
            ))}
          </Masonry>
        </StyledGrid>
      )}
    </>
  );
};

export default OfferGrid;
